const I = "24px";
export {
  I as KUI_ICON_SIZE_50
};
